const o = {
  name: "ArrowTop",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9998 5.41452L18.9997 11.4144L20.4139 10.0002L11.9997 1.58594L3.58545 10.0001L4.99966 11.4144L10.9998 5.41421L10.9998 22.0002H12.9998L12.9998 5.41452Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowTop
};
